export enum OrderType {
  ASC = 'asc',
  DESC = 'desc'
}

export enum OrderBy {
  EMAIL = 'email',
  NAME = 'name',
  PHONE = 'phone',
  CREATEDAT = 'createdAt',
  ORIGINNAME = 'originName',
  ORIGINTYPE = 'originType',
  ORIGINSTATUS = 'originStatus'
}